import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "24",
  fill: "none",
  viewBox: "0 0 23 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0C0A09",
      d: "M3 5.625A2.125 2.125 0 0 1 5.125 3.5h7.438a2.125 2.125 0 0 1 2.124 2.125v3.188h3.188A2.125 2.125 0 0 1 20 10.937v7.438a2.125 2.125 0 0 1-2.125 2.125h-7.437a2.125 2.125 0 0 1-2.126-2.125v-3.187H5.126A2.125 2.125 0 0 1 3 13.062zm2.125-1.062a1.06 1.06 0 0 0-1.062 1.062v7.438a1.063 1.063 0 0 0 1.062 1.062h7.438a1.06 1.06 0 0 0 1.062-1.062V5.625a1.06 1.06 0 0 0-1.062-1.062zm7.584 10.62q.307.478.67.898c-.795.611-1.778 1.064-2.941 1.373.189.23.479.674.59.921 1.194-.381 2.21-.897 3.066-1.587.825.706 1.847 1.237 3.113 1.564.141-.27.44-.715.668-.946-1.195-.269-2.186-.737-2.996-1.364.723-.794 1.298-1.754 1.722-2.93h1.274V12h-3.187v1.112h.812c-.338.897-.786 1.643-1.351 2.264a6 6 0 0 1-.441-.523c-.3.192-.644.305-.999.33"
    }, null, -1)
  ])))
}
export default { render: render }